import produce from 'immer';

const INITIAL_STATE = {
  profile: null,
  list: [],
  registry: {},
  loading: false,
  error: false
};

export default function userResign(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@userResigns/INDEX_REQUEST':
    case '@userResigns/CREATE_REQUEST':
    case '@userResigns/UPDATE_REQUEST':
    case '@userResigns/DELETE_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@userResigns/READ_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
        draft.registry = {};
      });

    case '@userResigns/CREATE_SUCCESS':
    case '@userResigns/UPDATE_SUCCESS':
    case '@userResigns/DELETE_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
      });

    case '@userResigns/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
      });

    case '@userResigns/READ_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = false;
        draft.registry = action.payload.data;
      });

    case '@userResigns/INDEX_FAILURE':
    case '@userResigns/CREATE_FAILURE':
    case '@userResigns/UPDATE_FAILURE':
    case '@userResigns/DELETE_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
      });

    case '@userResigns/READ_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.registry = {};
      });

    default:
      return state;
  }
}
